import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';

import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjChartModule } from '@grapecity/wijmo.angular2.chart';

import { KYMW9000Component } from './kymw9000.component';
import { KYMW9001Module } from '../kymw9001/kymw9001.module';
import { KYMW9002Module } from '../kymw9002/kymw9002.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetAssociatedUserManagementListService } from './api-services/get-associated-user-management-list.service';
import { GetAssociatedUserTypeService } from './api-services/get-associated-user-type.service'; 
import { DeleteAssociatedUserManagementSevice } from './api-services/delete-associated-user-management.service';
import { KYMW9005Module } from '../kymw9005/kymw9005.module';
import { KYMW9010Module } from '../kymw9010/kymw9010.module';
import { KYMW9003Module } from '../kymw9003/kymw9003.module';

/**
 * ユーザ管理画面 モジュール設定クラス
 *
 * @export KYMW9000Module
 * @class KYMW9000Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    WjGridModule,
    WjInputModule,
    WjChartModule,
    KYMW9001Module,
    KYMW9002Module,
    KYMW9003Module,
    KYMW9005Module,
    KYMW9010Module,
    AppCommonsModule,
  ],
  declarations: [
    KYMW9000Component,
  ],
  providers: [
    GetAssociatedUserManagementListService,
    GetAssociatedUserTypeService,
    DeleteAssociatedUserManagementSevice
  ],
})
export class KYMW9000Module {

}
